<script>
    import { onMount } from "svelte";

    import { prePopulateAccountOptions } from "../../stores";

    import { MultiSearchSelect } from "./index.svelte";

    import { v4 } from "uuid";

    import { cacheAccountPrePopulateSearchOptions } from "../../Utils/utilCache.svelte";

    export let inputID = "",
        searchResult = [],
        onChangeFunc = () => {},
        inputClass = "",
        searchTitle = "Doctor",
        titleClass,
        zIndex = 2; // Default MultiSearchSelect zIndex

    $: inputID = inputID || v4();

    let isLoadingAccountOptions = false;

    onMount(async () => {
        await loadAccountOptions();
    });

    const loadAccountOptions = async () => {
        isLoadingAccountOptions = true;

        await cacheAccountPrePopulateSearchOptions();

        isLoadingAccountOptions = false;
    };
</script>

<MultiSearchSelect
    title={searchTitle}
    {inputID}
    isDisabled={isLoadingAccountOptions}
    optionsArr={$prePopulateAccountOptions}
    bind:searchResult
    {onChangeFunc}
    {inputClass}
    {zIndex}
    {titleClass}
/>
